import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Row, Col, Modal, Card, Form, Input, message } from 'antd'
import _ from 'lodash'
import '../../css/patient.scss'
import { createNewCase } from '../../store/action/actioncases.action'
import { constants } from '../../constants'
import { useHistory } from 'react-router-dom'
var form = undefined

const CaseModal = (props) => {
  const history = useHistory()

  var handleCancel = () => {
    form && form.resetFields()
    props.onClose()
  }

  // When props.moveai is set the message is sent as 'MoveAI Message' and the
  // patient sees it from "MoveAI Health Support" instead of the clinic.
  var handleOk = () => {
    form.validateFields().then((values) => {
      const data = {
        // Gate the recipient by the explicitly clicked patient (props.record) first.
        // props.patient comes from Redux (state.patient.patient) and can be a stale
        // "currently open" patient left over from a detail page — using it here sent
        // every list-row message to the wrong patient (cross-patient leak).
        patientId: !_.isEmpty(props.record) ? props.record?._id : props.patient?._id,
        description: values.message,
        summary: values.subject,
        type: props.moveai
          ? constants.ACTION_CASE_TITLE.MOVEAI_MESSAGE
          : 'Surgeon Message',
        messageType: 'Conversation',
      }

      props
        .createNewCase(data)
        .then((res) => {
          if (res.status == constants.MESSAGE.SUCCESS) {
            form && form.resetFields()
            props.onClose()
            if (res.caseid && !props.record?._id)
              history.push({
                pathname: `/cases/${res.caseid}`,
                state: 'patient',
              })
             if(props.record?._id)
               message.success(
                 props.moveai ? 'Message sent from ' + constants.MOVEAI_SUPPORT_NAME + '.' : 'Notification sent.'
               )
          }
        })
        .catch((err) => {
          message.error('Failed to Create Case')
        })
    })
  }

  var renderPatients = () => {
    return (
      props.selectedPatients?.row &&
      props.selectedPatients?.row.map((patient, index) => {
        return (
          <Row className='notifyRow'>
            {_.upperFirst(patient.firstname) +
              ' ' +
              _.upperFirst(patient.lastname)}
          </Row>
        )
      })
    )
  }

  var renderBody = () => {
    return (
      <Card bordered={false}>
        <Row>
          <Col flex={'auto'}>
            <Form
              ref={(e) => (form = e)}
              name='normal_login'
              layout={'vertical'}
              // initialValues={props.filters}
              labelCol={{ span: 3 }}
            >
               <Form.Item
                name='subject'
                label='Subject'
                rules={[
                  {
                    required: true,
                    message: 'Please confirm your Subject!',
                  },
                ]}
              >
                <Input.TextArea allowClear rows={1} />
              </Form.Item>
              <Form.Item
                name='message'
                label='Message'
                rules={[
                  {
                    required: true,
                    message: 'Please confirm your Message!',
                  },
                ]}
              >
                <Input.TextArea allowClear rows={4} />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </Card>
    )
  }

  return (
    <Modal
      className={'filterModal'}
      title={
        props.moveai
          ? 'Send Message — from ' + constants.MOVEAI_SUPPORT_NAME
          : undefined
      }
      visible={props.visible}
      closable={false}
      maskClosable={false}
      onCancel={handleCancel}
      onOk={handleOk}
      width={'70%'}
      okText={props.moveai ? 'Send' : 'Create'}
    >
      {renderBody()}
    </Modal>
  )
}

const mapStateToProps = (state) => {
  return {
    patient: state.patient.patient,
    selectedPatients: state.patient?.selectedPatients,
    customer: state.profile.customer,
    error: state.patient.notifyError,
    message: state.patient.notifyMessage,
    stats: state.patient.stats,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    createNewCase: (input) => dispatch(createNewCase(input)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CaseModal)
